import {Space} from 'antd';
import {SizeType} from 'antd/es/config-provider/SizeContext';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {useMemo, FC} from 'react';

import {IFieldMeta} from 'entities/metadata';
import {IFormEntityData, IDatePickerState} from 'modules/data/data-types';

import {Field} from '../field/field';
import {EFormMode} from '../form-types';

interface IFieldsProps {
    formData?: IFormEntityData;
    entityName?: string;
    parentEntityName?: string;
    list?: IFieldMeta[];
    form?: FormInstance;
    spacingValue?: SizeType | number;
    isEditable?: boolean;
    editModeWidth?: boolean;
    formMode?: EFormMode;
    isDisableFields?: boolean;
    fieldClassNames?: cn.Argument;
    innerClassNames?: cn.Argument;
}

export const Fields: FC<IFieldsProps> = ({
    formData,
    list,
    parentEntityName,
    form,
    entityName,
    spacingValue,
    isEditable,
    editModeWidth,
    formMode,
    isDisableFields,
    fieldClassNames,
    innerClassNames,
}: IFieldsProps) => {
    const datePickerStates: IDatePickerState = {};
    const fields = useMemo(() => list?.sort(
        (a, b) => (a.order && b.order ? a.order - b.order : 0),
    ).map(field => (
        <Field
            formData={formData}
            entityName={entityName}
            parentEntityName={parentEntityName}
            key={field.key}
            fieldMeta={{
                ...field,
                isDisabled: isEditable === false || field.isDisabled,
            }}
            form={form}
            editModeWidth={editModeWidth}
            placeholder={field.placeholder}
            formMode={formMode}
            datePickerStates={datePickerStates}
            isDisableFields={isDisableFields}
            fieldClassNames={fieldClassNames}
            innerClassNames={innerClassNames}
        />
    )), [list, isEditable, editModeWidth, formData]);
    return spacingValue ? <Space size={spacingValue}>{fields}</Space> : <>{fields}</>;
};
